import {
  pList,
  rIstatistikPopup,
  rIstatistikPopupSonucListesi,
  rValue,
} from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_USTBILGIISTATISTIKDETAY,
    new Api.Bilgi.UstBilgiIstatistikDetayApi().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rIstatistikPopup> | null | undefined,
  error: IError | null | undefined
): IApiAction<rIstatistikPopupSonucListesi[]> =>
  ActionFunctions.action_async_complete_api<rIstatistikPopupSonucListesi[]>(
    ActionSubTypes.API_USTBILGIISTATISTIKDETAY,
    ((data?.Value?.SonucListesi as unknown) as rIstatistikPopupSonucListesi[]) || [],
    error
  );
